module.exports = __webpack_public_path__ + "0c30e80f1ff5fd61cbc31aabbcf549db.png";